import { render } from "./ReportBuilderSectionSettings.vue?vue&type=template&id=4a041fc8&scoped=true"
import script from "./ReportBuilderSectionSettings.vue?vue&type=script&lang=js"
export * from "./ReportBuilderSectionSettings.vue?vue&type=script&lang=js"

import "./ReportBuilderSectionSettings.vue?vue&type=style&index=0&id=4a041fc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a041fc8"],['__file',"resources/js/components/insights/report-building/ReportBuilderSectionSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a041fc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a041fc8', __exports__)) {
    api.reload('4a041fc8', __exports__)
  }
  
  module.hot.accept("./ReportBuilderSectionSettings.vue?vue&type=template&id=4a041fc8&scoped=true", () => {
    api.rerender('4a041fc8', render)
  })

}


export default __exports__